import React from 'react';

import Knock_Img1 from '../../../Images/gallery/photo/fashion/knockout/img-1.png';
import Knock_Img2 from '../../../Images/gallery/photo/fashion/knockout/img-2.png';
import Knock_Img3 from '../../../Images/gallery/photo/fashion/knockout/img-3.png';
import Knock_Img4 from '../../../Images/gallery/photo/fashion/knockout/img-4.png';
import Knock_Img5 from '../../../Images/gallery/photo/fashion/knockout/img-5.png';
import Knock_Img6 from '../../../Images/gallery/photo/fashion/knockout/img-6.png';
import Knock_Img7 from '../../../Images/gallery/photo/fashion/knockout/img-7.png';
import Knock_Img8 from '../../../Images/gallery/photo/fashion/knockout/img-8.png';
import Knock_Img9 from '../../../Images/gallery/photo/fashion/knockout/img-9.png';
import Knock_Img10 from '../../../Images/gallery/photo/fashion/knockout/img-10.png';
import Knock_Img11 from '../../../Images/gallery/photo/fashion/knockout/img-11.png';
import Knock_Img12 from '../../../Images/gallery/photo/fashion/knockout/img-12.png';
import Knock_Img13 from '../../../Images/gallery/photo/fashion/knockout/img-13.png';

export const Knockout_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>KNOCKOUT</span>,
  },
];

export const Knock_Images = [
  { id: 1, src: Knock_Img1, colSpan: 2, rowSpan: 6 },
  { id: 2, src: Knock_Img2, colSpan: 3, rowSpan: 4 },
  { id: 4, src: Knock_Img4, colSpan: 3, rowSpan: 4 },
  { id: 3, src: Knock_Img3, colSpan: 2, rowSpan: 2 },
  { id: 5, src: Knock_Img5, colSpan: 3, rowSpan: 3 },
  { id: 6, src: Knock_Img6, colSpan: 2, rowSpan: 3 },
  { id: 7, src: Knock_Img7, colSpan: 2, rowSpan: 5 },
  { id: 9, src: Knock_Img9, colSpan: 2, rowSpan: 3 },
  { id: 12, src: Knock_Img12, colSpan: 1, rowSpan: 3 },
  { id: 10, src: Knock_Img10, colSpan: 2, rowSpan: 3 },
  { id: 13, src: Knock_Img13, colSpan: 1, rowSpan: 4 },
  { id: 8, src: Knock_Img8, colSpan: 2, rowSpan: 5 },
  { id: 11, src: Knock_Img11, colSpan: 2, rowSpan: 3 },
];

export const Vassarette_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>VASSARETTE</span>,
  },
];

import Vassa_Img1 from '../../../Images/gallery/photo/fashion/vassarette-colection/img_1.png';
import Vassa_Img2 from '../../../Images/gallery/photo/fashion/vassarette-colection/img_2.png';
import Vassa_Img3 from '../../../Images/gallery/photo/fashion/vassarette-colection/img_3.png';
import Vassa_Img4 from '../../../Images/gallery/photo/fashion/vassarette-colection/img_4.png';
import Vassa_Img5 from '../../../Images/gallery/photo/fashion/vassarette-colection/img_5.png';
import Vassa_Img6 from '../../../Images/gallery/photo/fashion/vassarette-colection/img_6.png';

export const Vassarette_Images = [
  { id: 1, src: Vassa_Img1, colSpan: 2, rowSpan: 4 },
  { id: 2, src: Vassa_Img2, colSpan: 2, rowSpan: 4 },
  { id: 3, src: Vassa_Img3, colSpan: 2, rowSpan: 4 },
  { id: 4, src: Vassa_Img4, colSpan: 2, rowSpan: 4 },
  { id: 5, src: Vassa_Img5, colSpan: 2, rowSpan: 4 },
  { id: 6, src: Vassa_Img6, colSpan: 2, rowSpan: 4 },
];

export const Fruit1_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>FRUIT OF THE LOOM I</span>,
  },
];

import Fruit1_Img1 from '../../../Images/gallery/photo/fashion/fruit-1/img_1.png';
import Fruit1_Img2 from '../../../Images/gallery/photo/fashion/fruit-1/img_2.png';
import Fruit1_Img3 from '../../../Images/gallery/photo/fashion/fruit-1/img_3.png';
import Fruit1_Img4 from '../../../Images/gallery/photo/fashion/fruit-1/img_4.png';
import Fruit1_Img5 from '../../../Images/gallery/photo/fashion/fruit-1/img_5.png';
import Fruit1_Img6 from '../../../Images/gallery/photo/fashion/fruit-1/img_6.png';
import Fruit1_Img7 from '../../../Images/gallery/photo/fashion/fruit-1/img_7.png';
import Fruit1_Img8 from '../../../Images/gallery/photo/fashion/fruit-1/img_8.png';

export const Fruit1_Images = [
  { id: 1, src: Fruit1_Img1, colSpan: 1, rowSpan: 2 },
  { id: 2, src: Fruit1_Img2, colSpan: 1, rowSpan: 2 },
  { id: 3, src: Fruit1_Img3, colSpan: 1, rowSpan: 2 },
  { id: 4, src: Fruit1_Img4, colSpan: 1, rowSpan: 2 },
  { id: 5, src: Fruit1_Img5, colSpan: 1, rowSpan: 2 },
  { id: 6, src: Fruit1_Img6, colSpan: 1, rowSpan: 2 },
  { id: 7, src: Fruit1_Img7, colSpan: 3, rowSpan: 6 },
  { id: 8, src: Fruit1_Img8, colSpan: 3, rowSpan: 3 },
];

export const Fruit2_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>FRUIT OF THE LOOM II</span>,
  },
];

import Fruit2_Img1 from '../../../Images/gallery/photo/fashion/fruit-2/img_1.png';
import Fruit2_Img2 from '../../../Images/gallery/photo/fashion/fruit-2/img_2.png';
import Fruit2_Img3 from '../../../Images/gallery/photo/fashion/fruit-2/img_3.png';

export const Fruit2_Images = [
  { id: 1, src: Fruit2_Img1, colSpan: 2, rowSpan: 2 },
  { id: 2, src: Fruit2_Img2, colSpan: 3, rowSpan: 8 },
  { id: 3, src: Fruit2_Img3, colSpan: 2, rowSpan: 6 },
];

export const Curvation_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>CURVATION</span>,
  },
];

import Curv2_Img1 from '../../../Images/gallery/photo/fashion/curvation/img_1.png';
import Curv2_Img2 from '../../../Images/gallery/photo/fashion/curvation/img_2.png';
import Curv2_Img3 from '../../../Images/gallery/photo/fashion/curvation/img_3.png';

export const Curvation_Images = [
  { id: 1, src: Curv2_Img1, colSpan: 2, rowSpan: 3 },
  { id: 2, src: Curv2_Img2, colSpan: 2, rowSpan: 3 },
  { id: 3, src: Curv2_Img3, colSpan: 2, rowSpan: 3 },
];

export const Vassarette2_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>VASSARETTE</span>,
  },
];

import Vass_Img1 from '../../../Images/gallery/photo/fashion/vassarette/img_1.png';
import Vass_Img2 from '../../../Images/gallery/photo/fashion/vassarette/img_2.png';
import Vass_Img3 from '../../../Images/gallery/photo/fashion/vassarette/img_3.png';
import Vass_Img4 from '../../../Images/gallery/photo/fashion/vassarette/img_4.png';

export const Vassarette2_Images = [
  { id: 1, src: Vass_Img1, colSpan: 2, rowSpan: 8 },
  { id: 2, src: Vass_Img2, colSpan: 2, rowSpan: 3 },
  { id: 3, src: Vass_Img3, colSpan: 2, rowSpan: 8 },
  { id: 4, src: Vass_Img4, colSpan: 2, rowSpan: 3 },
];

export const FICJ_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>International Jewish Film Festival</span>,
  },
];

import Ficj_Img1 from '../../../Images/gallery/photo/retrato/ficj/img_1.png';
import Ficj_Img2 from '../../../Images/gallery/photo/retrato/ficj/img_2.png';
import Ficj_Img3 from '../../../Images/gallery/photo/retrato/ficj/img_3.png';
import Ficj_Img4 from '../../../Images/gallery/photo/retrato/ficj/img_4.png';
import Ficj_Img5 from '../../../Images/gallery/photo/retrato/ficj/img_5.png';
import Ficj_Img6 from '../../../Images/gallery/photo/retrato/ficj/img_6.png';
import Ficj_Img7 from '../../../Images/gallery/photo/retrato/ficj/img_7.png';

export const FICJ_Images = [
  { id: 1, src: Ficj_Img1, colSpan: 1, rowSpan: 3 },
  { id: 2, src: Ficj_Img2, colSpan: 1, rowSpan: 3 },
  { id: 3, src: Ficj_Img3, colSpan: 1, rowSpan: 3 },
  { id: 6, src: Ficj_Img6, colSpan: 1, rowSpan: 3 },
  { id: 5, src: Ficj_Img5, colSpan: 1, rowSpan: 3 },
  { id: 4, src: Ficj_Img4, colSpan: 1, rowSpan: 3 },
  { id: 7, src: Ficj_Img7, colSpan: 1, rowSpan: 3 },
];

export const Gire_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>GIRE</span>,
  },
];

import Gire_Img1 from '../../../Images/gallery/gire/col-2_img-2.png';
import Gire_Img2 from '../../../Images/gallery/gire/col-2_img-1.png';
import Gire_Img3 from '../../../Images/gallery/gire/col-1_img-2.png';
import Gire_Img4 from '../../../Images/gallery/gire/col-1_img-1.png';
import Gire_Img5 from '../../../Images/gallery/gire/col-1_img-3.png';
import Gire_Img6 from '../../../Images/gallery/gire/col-2_img-3.png';
import Gire_Img7 from '../../../Images/gallery/gire/col-3_img-1.png';
import Gire_Img8 from '../../../Images/gallery/gire/col-1_img-4.png';
import Gire_Img9 from '../../../Images/gallery/gire/col-2_img-6.png';
import Gire_Img10 from '../../../Images/gallery/gire/col-1_img-5.png';
import Gire_Img11 from '../../../Images/gallery/gire/col-3_img-2.png';
import Gire_Img12 from '../../../Images/gallery/gire/col-3_img-4.png';
import Gire_Img13 from '../../../Images/gallery/gire/col-3_img-5.png';
import Gire_Img14 from '../../../Images/gallery/gire/col-3_img-6.png';
import Gire_Img15 from '../../../Images/gallery/gire/col-1_img-6.png';
import Gire_Img16 from '../../../Images/gallery/gire/col-2_img-4.png';
import Gire_Img17 from '../../../Images/gallery/gire/col-2_img-5.png';
import Gire_Img18 from '../../../Images/gallery/gire/col-3_img-3.png';
import Gire_Img19 from '../../../Images/gallery/gire/col-3_img-7.png';
import Gire_Img20 from '../../../Images/gallery/gire/col-1_img-7.png';
import Gire_Img21 from '../../../Images/gallery/gire/col-2_img-7.png';
import Gire_Img22 from '../../../Images/gallery/gire/col-1_img-8.png';
import Gire_Img23 from '../../../Images/gallery/gire/col-3_img-8.png';

export const Gire_Images = [
  { id: 1, src: Gire_Img1, colSpan: 4, rowSpan: 3 },
  { id: 2, src: Gire_Img2, colSpan: 4, rowSpan: 3 },
  { id: 3, src: Gire_Img3, colSpan: 4, rowSpan: 3 },
  { id: 4, src: Gire_Img4, colSpan: 4, rowSpan: 3 },
  { id: 5, src: Gire_Img5, colSpan: 3, rowSpan: 2 },
  { id: 6, src: Gire_Img6, colSpan: 2, rowSpan: 2 },
  { id: 7, src: Gire_Img7, colSpan: 3, rowSpan: 2 },
  { id: 8, src: Gire_Img8, colSpan: 3, rowSpan: 2 },
  { id: 9, src: Gire_Img9, colSpan: 5, rowSpan: 4 },
  { id: 10, src: Gire_Img10, colSpan: 3, rowSpan: 2 },
  { id: 11, src: Gire_Img11, colSpan: 4, rowSpan: 3 },
  { id: 12, src: Gire_Img12, colSpan: 2, rowSpan: 2 },
  { id: 13, src: Gire_Img13, colSpan: 2, rowSpan: 2 },
  { id: 14, src: Gire_Img14, colSpan: 2, rowSpan: 2 },
  { id: 15, src: Gire_Img15, colSpan: 2, rowSpan: 2 },
  { id: 16, src: Gire_Img16, colSpan: 4, rowSpan: 3 },
  { id: 17, src: Gire_Img17, colSpan: 4, rowSpan: 3 },
  { id: 18, src: Gire_Img18, colSpan: 4, rowSpan: 3 },
  { id: 19, src: Gire_Img19, colSpan: 4, rowSpan: 3 },
  { id: 20, src: Gire_Img20, colSpan: 4, rowSpan: 3 },
  { id: 21, src: Gire_Img21, colSpan: 4, rowSpan: 3 },
  { id: 22, src: Gire_Img22, colSpan: 4, rowSpan: 3 },
  { id: 23, src: Gire_Img23, colSpan: 4, rowSpan: 3 },
];

export const Gallos_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>GALLOS</span>,
  },
];

import Gallos_Img1 from '../../../Images/gallery/photo/deportes/gallos/img_1.png';
import Gallos_Img2 from '../../../Images/gallery/photo/deportes/gallos/img_2.png';
import Gallos_Img3 from '../../../Images/gallery/photo/deportes/gallos/img_3.png';
import Gallos_Img4 from '../../../Images/gallery/photo/deportes/gallos/img_4.png';
import Gallos_Img5 from '../../../Images/gallery/photo/deportes/gallos/img_5.png';
import Gallos_Img6 from '../../../Images/gallery/photo/deportes/gallos/img_6.png';
import Gallos_Img7 from '../../../Images/gallery/photo/deportes/gallos/img_7.png';
import Gallos_Img8 from '../../../Images/gallery/photo/deportes/gallos/img_8.png';
import Gallos_Img9 from '../../../Images/gallery/photo/deportes/gallos/img_9.png';

export const Gallos_Images = [
  { id: 1, src: Gallos_Img1, colSpan: 2, rowSpan: 5 },
  { id: 2, src: Gallos_Img2, colSpan: 2, rowSpan: 3 },
  { id: 3, src: Gallos_Img3, colSpan: 3, rowSpan: 3 },
  { id: 4, src: Gallos_Img4, colSpan: 3, rowSpan: 3 },
  { id: 5, src: Gallos_Img5, colSpan: 2, rowSpan: 4 },
  { id: 6, src: Gallos_Img6, colSpan: 2, rowSpan: 4 },
  { id: 7, src: Gallos_Img7, colSpan: 3, rowSpan: 3 },
  { id: 8, src: Gallos_Img8, colSpan: 2, rowSpan: 3 },
  { id: 9, src: Gallos_Img9, colSpan: 5, rowSpan: 5 },
];

export const Gatorade_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>GATORADE</span>,
  },
];

import Gatorade_Img1 from '../../../Images/gallery/photo/deportes/gatorade/img_1.png';
import Gatorade_Img2 from '../../../Images/gallery/photo/deportes/gatorade/img_2.png';
import Gatorade_Img3 from '../../../Images/gallery/photo/deportes/gatorade/img_3.png';
import Gatorade_Img4 from '../../../Images/gallery/photo/deportes/gatorade/img_4.png';
import Gatorade_Img5 from '../../../Images/gallery/photo/deportes/gatorade/img_5.png';

export const Gatorade_Images = [
  { id: 1, src: Gatorade_Img1, colSpan: 4, rowSpan: 5 },
  { id: 2, src: Gatorade_Img2, colSpan: 2, rowSpan: 5 },
  { id: 3, src: Gatorade_Img3, colSpan: 3, rowSpan: 4 },
  { id: 4, src: Gatorade_Img4, colSpan: 3, rowSpan: 4 },
  { id: 5, src: Gatorade_Img5, colSpan: 5, rowSpan: 4 },
];

export const Puma1_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>PUMA I</span>,
  },
];

import Puma1_Img1 from '../../../Images/gallery/photo/deportes/puma-1/img_1.png';
import Puma1_Img2 from '../../../Images/gallery/photo/deportes/puma-1/img_2.png';
import Puma1_Img3 from '../../../Images/gallery/photo/deportes/puma-1/img_3.png';
import Puma1_Img4 from '../../../Images/gallery/photo/deportes/puma-1/img_4.png';
import Puma1_Img5 from '../../../Images/gallery/photo/deportes/puma-1/img_5.png';
import Puma1_Img6 from '../../../Images/gallery/photo/deportes/puma-1/img_6.png';

export const Puma1_Images = [
  { id: 1, src: Puma1_Img1, colSpan: 2, rowSpan: 3 },
  { id: 2, src: Puma1_Img2, colSpan: 4, rowSpan: 6 },
  { id: 3, src: Puma1_Img3, colSpan: 2, rowSpan: 3 },
  { id: 4, src: Puma1_Img4, colSpan: 2, rowSpan: 3 },
  { id: 5, src: Puma1_Img5, colSpan: 2, rowSpan: 3 },
  { id: 6, src: Puma1_Img6, colSpan: 2, rowSpan: 3 },
];

export const Puma2_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>PUMA II</span>,
  },
];

import Puma2_Img1 from '../../../Images/gallery/photo/deportes/puma-2/img_1.png';
import Puma2_Img2 from '../../../Images/gallery/photo/deportes/puma-2/img_2.png';
import Puma2_Img3 from '../../../Images/gallery/photo/deportes/puma-2/img_3.png';
import Puma2_Img4 from '../../../Images/gallery/photo/deportes/puma-2/img_4.png';
import Puma2_Img5 from '../../../Images/gallery/photo/deportes/puma-2/img_5.png';
import Puma2_Img6 from '../../../Images/gallery/photo/deportes/puma-2/img_6.png';
import Puma2_Img7 from '../../../Images/gallery/photo/deportes/puma-2/img_7.png';

export const Puma2_Images = [
  { id: 1, src: Puma2_Img1, colSpan: 6, rowSpan: 5 },
  { id: 2, src: Puma2_Img2, colSpan: 4, rowSpan: 3 },
  { id: 3, src: Puma2_Img3, colSpan: 1, rowSpan: 1 },
  { id: 4, src: Puma2_Img4, colSpan: 1, rowSpan: 1 },
  { id: 5, src: Puma2_Img5, colSpan: 1, rowSpan: 2 },
  { id: 6, src: Puma2_Img6, colSpan: 3, rowSpan: 4 },
  { id: 7, src: Puma2_Img7, colSpan: 3, rowSpan: 4 },
];

export const Puma3_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>PUMA III</span>,
  },
];

import Puma3_Img1 from '../../../Images/gallery/photo/deportes/puma-3/img_1.png';
import Puma3_Img2 from '../../../Images/gallery/photo/deportes/puma-3/img_2.png';
import Puma3_Img3 from '../../../Images/gallery/photo/deportes/puma-3/img_3.png';
import Puma3_Img4 from '../../../Images/gallery/photo/deportes/puma-3/img_4.png';
import Puma3_Img5 from '../../../Images/gallery/photo/deportes/puma-3/img_5.png';
import Puma3_Img6 from '../../../Images/gallery/photo/deportes/puma-3/img_6.png';
import Puma3_Img7 from '../../../Images/gallery/photo/deportes/puma-3/img_7.png';
import Puma3_Img8 from '../../../Images/gallery/photo/deportes/puma-3/img_8.png';

export const Puma3_Images = [
  { id: 1, src: Puma3_Img1, colSpan: 3, rowSpan: 3 },
  { id: 2, src: Puma3_Img2, colSpan: 3, rowSpan: 3 },
  { id: 3, src: Puma3_Img3, colSpan: 3, rowSpan: 3 },
  { id: 4, src: Puma3_Img4, colSpan: 3, rowSpan: 3 },
  { id: 5, src: Puma3_Img5, colSpan: 3, rowSpan: 3 },
  { id: 6, src: Puma3_Img6, colSpan: 3, rowSpan: 3 },
  { id: 7, src: Puma3_Img7, colSpan: 3, rowSpan: 3 },
  { id: 8, src: Puma3_Img8, colSpan: 3, rowSpan: 3 },
];

export const Torres10_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>TORRES 10</span>,
  },
];

import Torres10_Img1 from '../../../Images/gallery/torres/img_1.png';
import Torres10_Img2 from '../../../Images/gallery/torres/img_2.png';
import Torres10_Img3 from '../../../Images/gallery/torres/img_3.png';
import Torres10_Img4 from '../../../Images/gallery/torres/img_4.png';
import Torres10_Img5 from '../../../Images/gallery/torres/img_5.png';

export const Torres10_Images = [
  { id: 1, src: Torres10_Img1, colSpan: 4, rowSpan: 3 },
  { id: 2, src: Torres10_Img2, colSpan: 5, rowSpan: 3 },
  { id: 3, src: Torres10_Img3, colSpan: 5, rowSpan: 3 },
  { id: 4, src: Torres10_Img4, colSpan: 4, rowSpan: 3 },
  { id: 5, src: Torres10_Img5, colSpan: 5, rowSpan: 3 },
];

export const Torres20_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>TORRES 20</span>,
  },
];

import Torres20_Img1 from '../../../Images/gallery/photo/drinks/torres-20/img_1.png';
import Torres20_Img2 from '../../../Images/gallery/photo/drinks/torres-20/img_2.png';

export const Torres20_Images = [
  { id: 1, src: Torres20_Img1, colSpan: 4, rowSpan: 6 },
  { id: 2, src: Torres20_Img2, colSpan: 4, rowSpan: 6 },
];

export const Real_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>RESERVA REAL</span>,
  },
];

export const Magna_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>RESERVA MAGNA</span>,
  },
];

export const Chateau_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>CHATEAU</span>,
  },
];

export const Codigo_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>CÓDIGO</span>,
  },
];

export const Vasija_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>VASIJA</span>,
  },
];

export const Vinas_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>VIÑAS VIEJAS</span>,
  },
];

export const Xa_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>XA</span>,
  },
];

export const Cultural_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>RETRATOS IDENTITARIOS</span>,
  },
];

import Cultural_Img1 from '../../../Images/gallery/photo/cultural/img_1.png';
import Cultural_Img2 from '../../../Images/gallery/photo/cultural/img_2.png';
import Cultural_Img3 from '../../../Images/gallery/photo/cultural/img_3.png';
import Cultural_Img4 from '../../../Images/gallery/photo/cultural/img_4.png';
import Cultural_Img5 from '../../../Images/gallery/photo/cultural/img_5.png';
import Cultural_Img6 from '../../../Images/gallery/photo/cultural/img_6.png';

export const Cultural_Images = [
  { id: 1, src: Cultural_Img1, colSpan: 4, rowSpan: 6 },
  { id: 2, src: Cultural_Img2, colSpan: 1, rowSpan: 3 },
  { id: 3, src: Cultural_Img3, colSpan: 1, rowSpan: 3 },
  { id: 4, src: Cultural_Img4, colSpan: 2, rowSpan: 5 },
  { id: 5, src: Cultural_Img5, colSpan: 3, rowSpan: 5 },
  { id: 6, src: Cultural_Img6, colSpan: 5, rowSpan: 7 },
];

export const Betvip_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>BETVIP</span>,
  },
];

import Betvip_Img1 from '../../../Images/gallery/photo/campanas/betvip/img_1.png';
import Betvip_Img2 from '../../../Images/gallery/photo/campanas/betvip/img_2.png';
import Betvip_Img3 from '../../../Images/gallery/photo/campanas/betvip/img_3.png';
import Betvip_Img4 from '../../../Images/gallery/photo/campanas/betvip/img_4.png';
import Betvip_Img5 from '../../../Images/gallery/photo/campanas/betvip/img_5.png';
import Betvip_Img6 from '../../../Images/gallery/photo/campanas/betvip/img_6.png';
import Betvip_Img7 from '../../../Images/gallery/photo/campanas/betvip/img_7.png';
import Betvip_Img8 from '../../../Images/gallery/photo/campanas/betvip/img_8.png';
import Betvip_Img9 from '../../../Images/gallery/photo/campanas/betvip/img_9.png';
import Betvip_Img10 from '../../../Images/gallery/photo/campanas/betvip/img_10.png';
import Betvip_Img11 from '../../../Images/gallery/photo/campanas/betvip/img_11.png';
import Betvip_Img12 from '../../../Images/gallery/photo/campanas/betvip/img_12.png';

export const Betvip_Images = [
  { id: 1, src: Betvip_Img1, colSpan: 4, rowSpan: 8 },
  { id: 2, src: Betvip_Img2, colSpan: 2, rowSpan: 4 },
  { id: 3, src: Betvip_Img3, colSpan: 2, rowSpan: 4 },
  { id: 4, src: Betvip_Img4, colSpan: 2, rowSpan: 4 },
  { id: 5, src: Betvip_Img5, colSpan: 4, rowSpan: 8 },
  { id: 6, src: Betvip_Img6, colSpan: 2, rowSpan: 4 },
  { id: 7, src: Betvip_Img7, colSpan: 2, rowSpan: 4 },
  { id: 8, src: Betvip_Img8, colSpan: 2, rowSpan: 4 },
  { id: 9, src: Betvip_Img9, colSpan: 2, rowSpan: 4 },
  { id: 10, src: Betvip_Img10, colSpan: 3, rowSpan: 6 },
  { id: 11, src: Betvip_Img11, colSpan: 3, rowSpan: 6 },
  { id: 12, src: Betvip_Img12, colSpan: 6, rowSpan: 12 },
];

export const Betcris_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>BETCRIS</span>,
  },
];

import Betcris_Img1 from '../../../Images/gallery/photo/campanas/betcris/img_1.png';
import Betcris_Img2 from '../../../Images/gallery/photo/campanas/betcris/img_2.png';

export const Betcris_Images = [
  { id: 1, src: Betcris_Img1, colSpan: 4, rowSpan: 8 },
  { id: 2, src: Betcris_Img2, colSpan: 4, rowSpan: 8 },
];

export const Idealz_Title = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    renderContent: () => <span>IDEALZ</span>,
  },
];
